module.exports = __webpack_public_path__ + "9b3be4f1b9029c6be3c22a13f57c0515.svg";